import PropTypes from 'prop-types';

import Button from 'shopper/components/Button';
import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';

import useMediaQuery from 'hooks/useMediaQuery';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';
import { fromTextToDomId } from 'lib/string';
import { scrollToElement } from 'lib/utils';

import { useTopbar } from 'providers/TopbarProvider';

const Navigation = ({ gaEventCategory, titles }) => {
  const { topbarDesktop, topbarMobile } = useTopbar();
  const { isMd } = useMediaQuery();

  if (!titles || titles.length === 0) {
    return null;
  }

  return (
    <nav>
      <Heading as="h2" size="size3">
        {placeholder('titles.managedLandingNavigation')}
      </Heading>
      <Text className="mb-4 mt-2">
        {placeholder('descriptions.managedLandingNavigation')}
      </Text>
      <div className="flex w-full gap-x-4 overflow-x-auto scrollbar-none md:flex md:flex-wrap md:gap-3">
        {titles.map((title) => (
          <Button
            key={title}
            as="a"
            className="!min-w-auto px-4 focus:outline-none focus:ring-0"
            href={`#${fromTextToDomId(title)}`}
            size="size3"
            type="neutral-stroke"
            onClick={(e) => {
              e.preventDefault();

              const el = document.getElementById(fromTextToDomId(title));
              const topbar = isMd ? topbarDesktop : topbarMobile;

              if (el) {
                scrollToElement(el.offsetTop - topbar.height);
              }

              sendEvent({
                action: 'click_anchor_lp',
                category: gaEventCategory,
                label: title,
              });
            }}
          >
            {title}
          </Button>
        ))}
      </div>
    </nav>
  );
};

Navigation.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  titles: PropTypes.arrayOf(PropTypes.string),
};

export default Navigation;
